<template>
	<section class="goods-section">
		<div class="goods-container">
			<!-- 标题区域 -->
			<div class="section-header center">
				<h2 class="section-title">{{ $t('cargoTypes.title') }}</h2>
				<div class="section-divider"></div>
				<p class="section-subtitle">{{ $t('cargoTypes.subtitle') }}</p>
			</div>

			<!-- 主内容区域 - 左右两列布局 -->
			<div class="content-layout">
				<!-- 左侧：普通货物 + 特殊货物 -->
				<div class="left-column">
					<!-- 普通货物卡片 -->
					<div class="cargo-card general-card">
						<div class="card-accent"></div>
						<div class="card-inner">
							<div class="card-header">
								<div class="icon-box general-icon">
									<i class="fas fa-box-open"></i>
								</div>
								<div class="header-text">
									<h3>{{ $t('cargoTypes.general.title') }}</h3>
									<p>{{ $t('cargoTypes.general.description') }}</p>
								</div>
							</div>
							<div class="card-body">
								<p class="body-text">{{ $t('cargoTypes.general.commonItems') }}</p>
								<div class="tags-wrap">
									<span v-for="(tag, index) in $t('cargoTypes.general.tags')" :key="index" class="cargo-tag">
										{{ tag }}
									</span>
								</div>
							</div>
						</div>
					</div>

					<!-- 特殊货物卡片 -->
					<div class="cargo-card special-card">
						<div class="card-accent"></div>
						<div class="card-inner">
							<div class="card-header">
								<div class="icon-box special-icon">
									<i class="fas fa-star"></i>
								</div>
								<div class="header-text">
									<h3>{{ $t('cargoTypes.special.title') }}</h3>
									<p>{{ $t('cargoTypes.special.description') }}</p>
								</div>
							</div>
							<div class="card-body">
								<div class="special-grid">
									<div v-for="(item, index) in $t('cargoTypes.special.items')" :key="index" class="special-item">
										<div class="item-icon-wrap">
											<i :class="item.icon"></i>
										</div>
										<span class="item-name">{{ item.name }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 右侧：危险品卡片（重新布局） -->
				<div class="right-column">
					<div class="cargo-card dangerous-card">
						<div class="card-accent"></div>
						<div class="card-inner">
							<!-- 卡片头部 -->
							<div class="card-header">
								<div class="icon-box dangerous-icon">
									<i class="fas fa-radiation-alt"></i>
								</div>
								<div class="header-text">
									<h3>{{ $t('cargoTypes.dangerous.title') }}</h3>
									<p>{{ $t('cargoTypes.dangerous.description') }}</p>
								</div>
							</div>

							<!-- 危险品分类网格 - 3列 x 3行 -->
							<div class="danger-grid">
								<div v-for="(classItem, index) in $t('cargoTypes.dangerous.classes')" :key="index" class="danger-item">
									<div class="danger-flip-card">
										<div class="danger-flip-front">
											<img v-lazy-img="dangerImages[index]" :alt="classItem.class" />
										</div>
										<div class="danger-flip-back">
											<span v-html="classItem.class"></span>
										</div>
									</div>
								</div>
							</div>

							<!-- 注意事项 + 紧急帮助 合并区域 -->
							<div class="danger-footer">
								<!-- 注意事项 -->
								<div class="warning-box">
									<div class="warning-header">
										<i class="fas fa-exclamation-triangle"></i>
										<span>{{ $t('cargoTypes.dangerous.notes.title') }}</span>
									</div>
									<ul class="warning-list">
										<!-- 修正点：移除 template 上的 key，为内部 li 添加 key -->
										<template v-for="(note, noteIndex) in $t('cargoTypes.dangerous.notes.items')">
											<li v-if="typeof note === 'string'" :key="`note-${noteIndex}`" class="warning-item">
												<span class="warning-dot"></span>
												<span>{{ note }}</span>
											</li>
											<template v-else>
												<li :key="`group-${noteIndex}`" class="warning-item">
													<span class="warning-dot"></span>
													<span>{{ note.title }}</span>
												</li>
												<li v-for="(sub, subIdx) in note.items" :key="`sub-${noteIndex}-${subIdx}`" class="warning-sub-item">
													<span class="sub-dot"></span>
													<span>{{ sub }}</span>
												</li>
											</template>
										</template>
									</ul>
								</div>

								<!-- 紧急帮助 -->
								<!-- <div class="emergency-box">
									<div class="emergency-icon">
										<i class="fas fa-headset"></i>
									</div>
									<div class="emergency-content">
										<div class="emergency-title">{{ $t('cargoTypes.dangerous.emergency.title') || '需要紧急帮助？' }}</div>
										<p class="emergency-desc">{{ $t('cargoTypes.dangerous.emergency.desc') || '我们的专业团队随时为您提供7×24小时的全方位物流支持' }}</p>
										<div class="emergency-phone">
											<i class="fas fa-phone-alt"></i>
											<span>13401038003</span>
										</div>
									</div>
								</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'OperableGoods',
	data() {
		return {
			dangerImages: [
				require('@/assets/images/class1.png'),
				require('@/assets/images/class2.png'),
				require('@/assets/images/class3.png'),
				require('@/assets/images/class4.png'),
				require('@/assets/images/class5.png'),
				require('@/assets/images/class6.png'),
				require('@/assets/images/class7.png'),
				require('@/assets/images/class8.png'),
				require('@/assets/images/class9.png')
			]
		}
	}
}
</script>

<style lang="scss" scoped>
// === Design System Variables ===
$primary: #0052CC;
$primary-dark: #0043A8;
$primary-light: #3B7FFF;
$silver: #8E9EAB;
$light: #F4F7FB;
$body: #5B6C7F;
$heading: #0A1628;
$danger: #ef4444;
$warning: #f59e0b;
$success: #22c55e;

// === Responsive Breakpoints ===
$bp-desktop: 1200px;
$bp-tablet-lg: 992px;
$bp-tablet: 768px;
$bp-mobile: 480px;

/* ========================================
   基础容器
   ======================================== */
.goods-section {
	font-family: 'Rubik', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
	color: $body;
	line-height: 1.6;
	padding: clamp(40px, 5vw, 80px) 0;
	background: #fff;
}

.goods-container {
	max-width: 1280px;
	margin: 0 auto;
	padding: 0 clamp(16px, 3vw, 40px);
}

/* ========================================
   Section Header
   ======================================== */
.section-header {
	text-align: center;
	margin-bottom: clamp(28px, 4vw, 50px);

	.section-title {
		font-size: clamp(1.5rem, 3.5vw, 2.6rem);
		font-weight: 700;
		color: $heading;
		margin: 0 0 12px 0;
		letter-spacing: -0.5px;
		line-height: 1.2;

		&::after {
			content: '';
			display: block;
			width: clamp(50px, 6vw, 80px);
			height: 4px;
			background: linear-gradient(to right, $primary, $primary-light);
			border-radius: 2px;
			margin: 12px auto 0;
		}
	}

	.section-subtitle {
		font-size: clamp(0.88rem, 1.2vw, 1rem);
		color: $body;
		line-height: 1.7;
		max-width: 760px;
		margin: clamp(12px, 2vw, 18px) auto 0;
		font-weight: 400;
		padding: 0 8px;
	}
}

/* ========================================
   主内容布局 — 左右两列
   ======================================== */
.content-layout {
	display: grid;
	grid-template-columns: 1fr 1.4fr;
	gap: clamp(20px, 2.5vw, 30px);
	align-items: stretch;

	@media (max-width: $bp-tablet-lg) {
		grid-template-columns: 1fr;

		.cargo-card {
			height: auto;
			min-height: 0;
		}
	}
}

.left-column,
.right-column {
	display: flex;
	flex-direction: column;
	gap: clamp(18px, 2vw, 24px);
}

/* ========================================
   卡片基础样式
   ======================================== */
.cargo-card {
	position: relative;
	background: #fff;
	border-radius: 16px;
	overflow: hidden;
	border: 1px solid rgba(0, 82, 204, 0.08);
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
	transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
	height: 100%;
	display: flex;
	flex-direction: column;

	&:hover {
		box-shadow: 0 12px 36px rgba(0, 82, 204, 0.16);
		transform: translateY(-4px);
		border-color: rgba(0, 82, 204, 0.2);
	}

	@media (max-width: $bp-mobile) {
		&:hover {
			transform: translateY(-2px);
		}
	}
}

.card-accent {
	height: 4px;
}

.general-card .card-accent {
	background: linear-gradient(90deg, $primary, $primary-light);
}
.special-card .card-accent {
	background: linear-gradient(90deg, $primary-light, #7eb8ff);
}
.dangerous-card .card-accent {
	background: linear-gradient(90deg, $warning, $danger);
}

.card-inner {
	padding: clamp(16px, 2.5vw, 28px);
	flex: 1;
	display: flex;
	flex-direction: column;
}

/* ========================================
   卡片头部
   ======================================== */
.card-header {
	display: flex;
	align-items: flex-start;
	gap: clamp(12px, 1.5vw, 16px);
	margin-bottom: clamp(16px, 2vw, 22px);
}

.icon-box {
	width: clamp(44px, 5vw, 56px);
	height: clamp(44px, 5vw, 56px);
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	i {
		font-size: clamp(20px, 2.2vw, 26px);
		color: #fff;
	}
}

.general-icon {
	background: linear-gradient(135deg, $primary, $primary-light);
	box-shadow: 0 4px 14px rgba(0, 82, 204, 0.3);
}
.special-icon {
	background: linear-gradient(135deg, $primary-light, #7eb8ff);
	box-shadow: 0 4px 14px rgba(0, 82, 204, 0.3);
}
.dangerous-icon {
	background: linear-gradient(135deg, $warning, $danger);
	box-shadow: 0 4px 14px rgba(245, 87, 108, 0.3);
}

.header-text {
	flex: 1;

	h3 {
		font-size: clamp(1.05rem, 1.3vw, 1.3rem);
		font-weight: 700;
		color: $heading;
		margin: 0 0 4px 0;
	}

	p {
		font-size: clamp(0.82rem, 1vw, 0.92rem);
		color: $body;
		margin: 0;
		line-height: 1.5;
	}
}

/* ========================================
   卡片内容
   ======================================== */
.card-body {
	flex: 1;

	.body-text {
		font-size: clamp(0.82rem, 1vw, 0.92rem);
		color: $body;
		line-height: 1.7;
		margin-bottom: clamp(14px, 1.8vw, 18px);
	}
}

/* ========================================
   标签
   ======================================== */
.tags-wrap {
	display: flex;
	flex-wrap: wrap;
	gap: clamp(6px, 1vw, 10px);
}

.cargo-tag {
	padding: clamp(5px, 0.8vw, 8px) clamp(12px, 1.5vw, 18px);
	border-radius: 24px;
	font-size: clamp(0.75rem, 0.85vw, 0.85rem);
	font-weight: 500;
	background: rgba(0, 82, 204, 0.06);
	color: $primary;
	border: 1px solid rgba(0, 82, 204, 0.18);
	transition: all 0.25s ease;

	&:hover {
		background: $primary;
		color: #fff;
		border-color: $primary;
	}
}

/* ========================================
   特殊货物网格
   ======================================== */
.special-grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: clamp(5px, 0.2vw, 3px);;

	@media (max-width: $bp-desktop) {
		grid-template-columns: repeat(3, 1fr);
	}
	@media (max-width: $bp-tablet) {
		grid-template-columns: repeat(4, 1fr);
	}
	@media (max-width: $bp-mobile) {
		grid-template-columns: repeat(2, 1fr);
	}
}

.special-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: clamp(10px, 1.5vw, 16px) clamp(6px, 1vw, 8px);
	background: $light;
	border-radius: 12px;
	border: 1px solid rgba(0, 82, 204, 0.06);
	transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);

	&:hover {
		background: linear-gradient(135deg, $primary-light, $primary);
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(0, 82, 204, 0.2);

		.item-icon-wrap {
			background: rgba(255, 255, 255, 0.3);
			color: #fff;
		}
		.item-name {
			color: #fff;
		}
	}
}

.item-icon-wrap {
	width: clamp(34px, 3.5vw, 42px);
	height: clamp(34px, 3.5vw, 42px);
	border-radius: 10px;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	color: $primary;
	margin-bottom: 6px;
	transition: all 0.3s;
	border: 1px solid rgba(0, 82, 204, 0.1);

	i {
		font-size: clamp(18px, 1.8vw, 22px);
	}
}

.item-name {
	font-size: clamp(0.7rem, 0.8vw, 0.78rem);
	font-weight: 500;
	color: $heading;
	text-align: center;
	transition: color 0.3s;
}

/* ========================================
   危险品网格 — 3列
   ======================================== */
.danger-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: clamp(10px, 1.2vw, 14px);
	margin-bottom: clamp(18px, 2vw, 24px);

	@media (max-width: $bp-tablet) {
		grid-template-columns: repeat(3, 1fr);
	}
	@media (max-width: ($bp-tablet - 1px)) {
		grid-template-columns: repeat(3, 1fr);
	}
	@media (max-width: $bp-mobile) {
		grid-template-columns: repeat(2, 1fr);
		gap: 8px;
	}
}

.danger-item {
	perspective: 800px;
	padding: clamp(14px, 1.8vw, 20px) clamp(10px, 1.2vw, 14px);
	background: $light;
	border-radius: 12px;
	border: 2px solid transparent;
	transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
	cursor: pointer;
	min-height: clamp(120px, 14vw, 155px);
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		border-color: $danger;
		transform: translateY(-3px);
		box-shadow: 0 6px 20px rgba(239, 68, 68, 0.15);
		background: #fff;
	}

	@media (max-width: $bp-mobile) {
		min-height: 95px;
		padding: 10px 6px;
	}
}

.danger-flip-card {
	width: 100%;
	height: 100%;
	position: relative;
	transform-style: preserve-3d;
	transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);
	min-height: clamp(90px, 10vw, 115px);
}

.danger-item:hover .danger-flip-card {
	transform: rotateY(180deg);
}

.danger-flip-front,
.danger-flip-back {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 10px;
}

.danger-flip-front {
	background: transparent;

	img {
		// width: 80px;
		height: 145px;
		object-fit: contain;
		pointer-events: none;

		@media (max-width: $bp-mobile) {
			width: 60px;
			height: 60px;
		}
	}
}

.danger-flip-back {
	background: linear-gradient(135deg, #fef2f2, #fff1f1);
	transform: rotateY(180deg);
	border: 2px solid rgba(239, 68, 68, 0.15);

	span {
		font-size: clamp(0.85rem, 1vw, 0.98rem);
		font-weight: 700;
		color: $danger;
		text-align: center;
		line-height: 1.4;
		white-space: pre-line;
		word-break: break-word;
		max-width: 100%;
		padding: 6px;

		@media (max-width: $bp-mobile) {
			font-size: 0.72rem;
			padding: 4px;
		}
	}
}

/* ========================================
   底部区域：注意事项 + 紧急帮助
   ======================================== */
.danger-footer {
	display: flex;
	flex-direction: column;
	gap: clamp(14px, 1.6vw, 18px);
	margin-top: auto;
}

.warning-box {
	background: linear-gradient(135deg, #fff5f5, #fef0f0);
	border-radius: 12px;
	padding: clamp(14px, 1.8vw, 20px) clamp(16px, 2vw, 22px);
	border-left: 4px solid $danger;
}

.warning-header {
	display: flex;
	align-items: center;
	gap: 10px;
	font-size: clamp(0.88rem, 0.95vw, 0.98rem);
	font-weight: 700;
	color: $danger;
	margin-bottom: 10px;

	i {
		font-size: clamp(18px, 1.6vw, 20px);
	}
}

.warning-list {
	list-style: none;
	margin: 0;
	padding: 0;
}

.warning-item {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	font-size: clamp(0.8rem, 0.9vw, 0.88rem);
	color: $heading;
	margin-bottom: 6px;
	font-weight: 500;

	.warning-dot {
		width: 6px;
		height: 6px;
		background: $danger;
		border-radius: 50%;
		margin-top: 7px;
		flex-shrink: 0;
	}
}

.warning-sub-item {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	font-size: clamp(0.75rem, 0.85vw, 0.82rem);
	color: $body;
	padding-left: 16px;
	margin-bottom: 4px;

	.sub-dot {
		width: 4px;
		height: 4px;
		background: $silver;
		border-radius: 50%;
		margin-top: 6px;
		flex-shrink: 0;
	}
}

.emergency-box {
	display: flex;
	align-items: center;
	gap: clamp(14px, 1.8vw, 20px);
	background: linear-gradient(135deg, #f0f7ff, #e8f0fe);
	border-radius: 12px;
	padding: clamp(14px, 1.8vw, 20px) clamp(16px, 2vw, 22px);
	border: 1px solid rgba(0, 82, 204, 0.1);
	transition: all 0.3s;

	&:hover {
		box-shadow: 0 4px 16px rgba(0, 82, 204, 0.08);
		border-color: rgba(0, 82, 204, 0.2);
	}
}

.emergency-icon {
	width: clamp(44px, 4.5vw, 52px);
	height: clamp(44px, 4.5vw, 52px);
	border-radius: 50%;
	background: linear-gradient(135deg, $primary, $primary-light);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	box-shadow: 0 4px 14px rgba(0, 82, 204, 0.25);

	i {
		font-size: clamp(20px, 2vw, 24px);
		color: #fff;
	}

	@media (max-width: $bp-mobile) {
		width: 38px;
		height: 38px;
		i {
			font-size: 17px;
		}
	}
}

.emergency-content {
	flex: 1;
	min-width: 0;
}

.emergency-title {
	font-size: clamp(0.92rem, 1.05vw, 1.05rem);
	font-weight: 700;
	color: $heading;
	margin-bottom: 2px;
}

.emergency-desc {
	font-size: clamp(0.78rem, 0.88vw, 0.85rem);
	color: $body;
	margin: 0 0 6px 0;
	line-height: 1.5;
}

.emergency-phone {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-size: clamp(1rem, 1.1vw, 1.1rem);
	font-weight: 700;
	color: $primary;
	background: rgba(0, 82, 204, 0.08);
	padding: 4px 14px 4px 10px;
	border-radius: 20px;

	i {
		font-size: clamp(14px, 1.2vw, 16px);
	}

	@media (max-width: $bp-mobile) {
		font-size: 0.9rem;
		padding: 3px 10px 3px 8px;
	}
}

/* ========================================
   Tablet Fine-tuning
   ======================================== */
@media (min-width: $bp-tablet) and (max-width: ($bp-tablet-lg - 1px)) {
	.content-layout {
		max-width: 640px;
		margin: 0 auto;
	}
}

/* ========================================
   Mobile Fine-tuning
   ======================================== */
@media (max-width: ($bp-mobile - 1px)) {
	.goods-section {
		padding: 30px 0;
	}
	.section-header {
		margin-bottom: 24px;
	}
	.content-layout {
		gap: 16px;
	}
	.left-column,
	.right-column {
		gap: 14px;
	}
	.card-inner {
		padding: 14px;
	}
	.card-header {
		margin-bottom: 12px;
	}
	.icon-box {
		width: 40px;
		height: 40px;
		i {
			font-size: 18px;
		}
	}
	.header-text h3 {
		font-size: 1rem;
	}

	.danger-grid {
		gap: 8px;
	}
	.danger-item {
		min-height: 85px;
		padding: 8px 4px;
	}
	.danger-flip-front img {
		width: 56px;
		height: 56px;
	}
	.danger-flip-back span {
		font-size: 0.65rem;
	}

	.warning-box {
		padding: 12px 14px;
	}
	.emergency-box {
		padding: 12px 14px;
		gap: 10px;
	}
	.emergency-desc {
		font-size: 0.72rem;
	}
	.emergency-phone {
		font-size: 0.82rem;
		padding: 2px 8px 2px 6px;
	}
}
</style>